module.exports = __webpack_public_path__ + "static/media/maintenance_system.ee030936.png";